import { sva } from 'styled-system/css';

export const dashedTitleRecipe = sva({
  slots: ['title'],
  base: {
    title: {
      color: 'purple-primary',
      textStyle: 'b1',
      width: 'fit-content',
      textWrap: 'nowrap',
    },
  },
  variants: {
    color: {
      blue: {
        title: { color: 'blue' },
      },
      purpleLight: {
        title: { color: 'purple-3' },
      },
      orange: {
        title: { color: 'orange' },
      },
      green: {
        title: { color: 'green-1' },
      },
      pink: {
        title: { color: 'pink' },
      },
      black: {
        title: { color: 'black-3' },
      },
      yellow: {
        title: { color: 'yellow' },
      },
    },
  },
});
